import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="bg-gradient-to-br from-[#FFB800] to-[#FFA000] text-white py-16">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium">
              2026年最新版
            </div>
            <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium">
              還元率1%以上
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            ポイント還元率が高い<br className="md:hidden" />クレジットカード比較
          </h1>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
            使えば使うほどお得！基本還元率1%以上、特定店舗で最大7%還元など、ポイントがザクザク貯まる高還元率カードを徹底比較しました。
          </p>
          <div className="flex items-center justify-center gap-4 text-sm text-white/80 mb-12">
            <div className="flex items-center gap-2">
              <i className="ri-time-line"></i>
              <span>更新日：2026年1月</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-article-line"></i>
              <span>読了時間：約8分</span>
            </div>
          </div>

          {/* 1️⃣ ファーストビュー即決ブロック */}
          <div className="bg-white text-gray-900 rounded-2xl p-8 shadow-2xl max-w-2xl mx-auto">
            <div className="flex items-center gap-2 mb-4 justify-center">
              <div className="px-3 py-1 bg-[#FFB800] text-white text-xs font-bold rounded-full whitespace-nowrap">
                迷ったらコレ！
              </div>
              <div className="px-3 py-1 bg-red-500 text-white text-xs font-bold rounded-full whitespace-nowrap">
                No.1おすすめ
              </div>
            </div>
            
            <h2 className="text-2xl font-bold mb-4">三井住友カード（NL）</h2>
            
            <div className="grid grid-cols-3 gap-4 mb-6">
              <div>
                <div className="text-sm text-gray-600 mb-1">還元率</div>
                <div className="text-xl font-bold text-[#FFB800]">最大7%</div>
              </div>
              <div>
                <div className="text-sm text-gray-600 mb-1">年会費</div>
                <div className="text-xl font-bold text-green-600">永年無料</div>
              </div>
              <div>
                <div className="text-sm text-gray-600 mb-1">発行</div>
                <div className="text-xl font-bold text-gray-900">最短10秒</div>
              </div>
            </div>
            
            <ul className="space-y-2 mb-6 text-left">
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-[#FFB800] text-xl mt-0.5"></i>
                <span className="text-gray-700">対象のコンビニ・飲食店で最大7%還元</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-[#FFB800] text-xl mt-0.5"></i>
                <span className="text-gray-700">年会費永年無料で維持コスト0円</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-[#FFB800] text-xl mt-0.5"></i>
                <span className="text-gray-700">最短10秒でカード番号発行</span>
              </li>
            </ul>
            
            <div className="flex flex-col sm:flex-row gap-3">
              <Link 
                to="/mitsui"
                className="flex-1 px-6 py-4 bg-[#FFB800] text-white text-center rounded-lg hover:bg-[#FFA000] transition-colors font-bold text-lg whitespace-nowrap cursor-pointer"
              >
                詳細ページを見る
              </Link>
              <a 
                href="#apply"
                className="flex-1 px-6 py-4 bg-white text-[#FFB800] text-center rounded-lg border-2 border-[#FFB800] hover:bg-[#FFB800]/5 transition-colors font-bold text-lg whitespace-nowrap cursor-pointer"
              >
                公式サイトはこちら
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
